import { articles, featuredArticleIds } from "@/mocks/articles";
import ArticleCard from "@/components/feature/ArticleCard";
import { SectionHeading } from "@/components/feature/PageHero";

export default function NotesPreview() {
  const featured = featuredArticleIds
    .map((id) => articles.find((item) => item.id === id))
    .filter((item): item is (typeof articles)[number] => Boolean(item));

  return (
    <section className="w-full border-y border-background-200 bg-background-100 px-4 py-12 md:px-6 md:py-16 lg:px-10">
      <SectionHeading
        title="求证笔记"
        description="把方法写下来，比结论更重要。这些笔记记录了我们整理 511 爆料时用到的流程、工具与判断标准。"
        action={{ label: "浏览全部笔记", to: "/articles" }}
      />
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {featured.map((article) => (
          <ArticleCard key={article.id} article={article} />
        ))}
      </div>
    </section>
  );
}